<template>
  <div>
    <el-form
      @submit.native.prevent
      class="dsf-online-login-tab-plan"
      label-width="1.8rem"
      :disabled="disabled"
      :css-disabled="disabled"
    >
      <el-form-item label="用户名">
        <span slot="label">
          <i class="iconfont icon-person"></i>
          <span class="label-text">用户名</span>
        </span>
        <el-input
          v-model.trim="username"
          :disabled="loading"
          :placeholder="userNamePlaceholder"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item label="密   码">
        <span slot="label">
          <i class="iconfont icon-mine_xgmm"></i>
          <span class="label-text">密码</span></span
        >
        <password-iframe-input
          v-model.trim="password"
          :placeholder="passwordPlaceholder"
          :disabled="disabled"
        />
      </el-form-item>
      <el-form-item label="验证码">
        <span slot="label">
          <i class="iconfont icon-anquan"></i>
          <span class="label-text">验证码</span></span
        >
        <el-input
          class="input-qrcode"
          v-model.trim="qrCode"
          :disabled="loading"
          :placeholder="'请输入验证码'"
          clearable
        >
          <template slot="append">
            <img v-show="qrCodeImg" :src="qrCodeImg" @click="getQrCode" />
          </template>
        </el-input>
      </el-form-item>
      <el-button
        class="btn-wrap"
        :loading="loading"
        native-type="submit"
        @click="checkQrCode('checkLogin')"
      >
        登录
      </el-button>
    </el-form>
    <transition name="dialogShow">
      <div v-show="showCheckSms" class="dsf-sc-login-tab-phone-dialog">
        <el-form  @submit.native.prevent>
          <div v-show="showCheckSms" class="dsf-sc-login-tab-phone-dialog_content login-dialog-show">
            <div class="dsf-sc-login-tab-phone-dialog_head login-dialog-head">
              <p class="dxyz">短信验证</p>
              <!-- <img src="static/img/project/smsDialogTitle.png" /> -->
              <dsf-icon class="dsf-sc-login-tab-phone-dialog-close-btn login-dialog-show-close" name="guanbi2" @click="showCheckSms = false"></dsf-icon>
            </div>
            <div class="dsf-sc-login-tab-phone-dialog_warp">
              <div class="dsf-sc-login-tab-phone-dialog_row">
                <div class="dsf-sc-login-tab-phone-dialog_row_label">手机号</div>
                <div class="dsf-sc-login-tab-phone-dialog_row_value">
                  <dsf-icon class="dsf-sc-login-tab-phone-dialog_row_icon" name="icon_phone"></dsf-icon>
                  <el-input v-model.trim="phone" :disabled="true" :placeholder="phonePlaceholder" name="text"> </el-input>
                </div>
              </div>
              <div class="dsf-sc-login-tab-phone-dialog_row">
                <div class="dsf-sc-login-tab-phone-dialog_row_label">验证码</div>
                <div class="dsf-sc-login-tab-phone-dialog_row_value">
                  <dsf-icon class="dsf-sc-login-tab-phone-dialog_row_icon" name="yanzhengma1"></dsf-icon>
                  <el-input v-model.trim="phoneCode" :disabled="loading" :placeholder="codePlaceholder" clearable name="text"> </el-input>
                  <div
                    @click="handleCode"
                    class="send-sms-code-btn"
                    :class="{
                      'send-sms-code-btn-disabled': loading || time > 0,
                    }"
                  >
                    获取验证码 <span v-show="time > 0">({{ time }})</span>
                  </div>
                </div>
              </div>
              <el-button style="width: 100%" type="primary" @click="submit('smsLogin')" native-type="submit" class="dsf-sc-login-tab-phone-dialog-sms-login-btn">
                登录
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
    </transition>
  </div>
</template>

<script>
const CodeTime = 3;
import PasswordIframeInput from "../../components/passwordInput/passwordIframeInput.vue";
export default {
  name: "TabDepartment",
  components: {
    PasswordIframeInput,
  },
  data() {
    return {
      showCheckSms: false,
      loading: false,
      username: "",
      password: "",
      phone: "",
      code: "",
      setIntervalCode: null,
      time: 0,
      qrCodeImg: "",
      qrCodeId: "",
      qrCode: "",
      phoneCode: "",
      phoneCodeId: "",
      smsLoginToken: "",
      smsSendTime: dsf.config.setting_public_sms_send_interval_time || 60,
    };
  },
  props: {
    userNamePlaceholder: {
      type: String,
      default: "请输入用户名",
    },
    passwordPlaceholder: {
      type: String,
      default: "请输入密码",
    },
    phonePlaceholder: {
      type: String,
      default: "请输入手机号码",
    },
    codePlaceholder: {
      type: String,
      default: "请输入验证码",
    },
    disabled: {
      default: false,
    },
    tabType: {
      type: String,
      default: "",
    }
  },
  computed: {
    qrCodeUrl() {
      return "/code/imageBase64?t=" + this.qrCodeTime;
    },
  },
  methods: {
    getQrCode() {
      dsf.http.get("/code/imageBase64").done(({ data, success }) => {
        if (success) {
          this.qrCodeImg = "data:image/png;base64," + data.imageBase64;
          this.qrCodeId = data.id;
          this.qrCode = "";
        }
      });
    },
    checkQrCode() {
      if (this.username === "") {
        dsf.layer.message("用户名不能为空！", false);
        return false;
      }
      let loading = dsf.layer.loading();
      dsf.http
        .post("secret/qrCode/smsCheck", {
          password: dsf.sm2.encode(
            dsf.md5(dsf.md5(this.password)),
            dsf.config.setting_public_smpublickey
          ),
          userName: this.username,
          code: this.qrCode,
          codeId: this.qrCodeId,
          loginType: "sms",
        })
        .then(({ data }) => {
          if (data.success) {
            this.phone = data.data.phone;
            this.smsLoginToken = data.data.smsLoginToken;
            if (!data.data.checkSms) {
              this.showCheckSms = true;
              return false;
            }
            this.submit("tokenLogin");
          } else {
            dsf.layer.message(data.message, false);
            this.getQrCode();
            this.showCheckSms = false;
            return false;
          }
        })
        .catch(() => {
          dsf.layer.message("服务器未知异常", false);
          this.getQrCode();
          return false;
        })
        .finally(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    toForgotPassword() {
      dsf.layer.openWindow("#/pc/dsfa/platformhome/forgetPassword");
    },
    handleCode() {
      this.username = _.trim(this.username);
      this.password = _.trim(this.password);
      this.phone = _.trim(this.phone);
      if (this.time > 0) {
        return dsf.layer.message(`${this.time}秒后才能再次发送`, false);
      }
      if (!this.verify()) {
        return;
      }
      if (!this.phone) {
        dsf.layer.message("手机号码不能为空！", false);
        return false;
      }
      this.getcode();
    },
    getcode() {
      if (!dsf.config.setting_public_smpublickey)
        return dsf.layer.message("没有获取到公钥", false);
      let params = {
        password: dsf.sm2.encode(
          dsf.md5(dsf.md5(this.password)),
          dsf.config.setting_public_smpublickey
        ),
        userName: this.username,
        phone: this.phone,
        smsLoginToken: this.smsLoginToken,
        loginType: "sms",
      };
      dsf.http
        .get(`/secret/qrCode/getSmsCode`, params)
        .then(({ data, success, message }) => {
          if (!data.success) {
            dsf.layer.message(data.message, false);
            this.getQrCode();
          } else {
            dsf.layer.message("短信验证码发送成功");
            this.time = this.smsSendTime || 60;
            this.setIntervalCode = setInterval(() => {
              if (this.time > 0) {
                this.time--;
              } else {
                this.time = 0;
                clearInterval(this.setIntervalCode);
              }
            }, 1000);
          }
        })
        .catch((err) => {
          console.error(err);
          this.getQrCode();
          if (err) {
            dsf.layer.message(err.message || "未知错误", false);
          }
        });
    },
    async submit(type) {
      if (!dsf.config.setting_public_smpublickey)
        return dsf.layer.message("没有获取到公钥", false);
      let code = this.phoneCode;
      if (type == "smsLogin") {
        code = this.phoneCode;
      } else {
        code = this.qrCode;
      }
      if (!this.verify()) {
        return;
      }
      if (!code) {
        dsf.layer.message("验证码不能为空！", false);
        return false;
      }
      this.loading = true;
      let params = {
        password: dsf.sm2.encode(
          dsf.md5(dsf.md5(this.password)),
          dsf.config.setting_public_smpublickey
        ),
        userName: this.username,
        phone: this.phone,
        code,
        smsLoginToken: this.smsLoginToken,
        loginType: "sms",
      };
      let loading = dsf.layer.loading();
      if(this.tabType == 'dreamH5oOkqK3' || this.tabType == 'dreambSYXku12') {
        dsf.http.post("/login/login4AssignApp", {...params,
          appKey: this.tabType
        }).done((res) => {
          if(res.success) {
            if(res.data.redirectPath) {
              location.replace(res.data.redirectPath);
            } else {
              dsf.layer.message("跳转路径不存在", false);
            }
          } else {
            dsf.layer.message(res.message, false);
          }
        }).catch((err) => {
          dsf.layer.message(err?.message || "未知错误", false);
        })
        .finally(() => {
          dsf.layer.closeLoading(loading);
          this.loading = false;
        });
      } else {
        this.$webAPI
        .login(params)
        .then((data) => {
          if (data && data.success) {
            if (data.userType == 2) {
              return this.saToLogin(data);
            } else {
              if (data.data.redirectPath) {
                location.replace(data.data.redirectPath);
              } else {
                dsf.layer.message("跳转路径不存在", false);
              }
            }
          } else {
            dsf.layer.message(data.message, false);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err) {
            dsf.layer.message(err.message || "未知错误", false);
          }
        })
        .finally(() => {
          dsf.layer.closeLoading(loading);
          this.loading = false;
        });
      }
    },
    verify() {
      if (this.username === "") {
        dsf.layer.message("用户名不能为空！", false);
        return false;
      }
      if (this.password === "") {
        dsf.layer.message("密码不能为空！", false);
        return false;
      }
      return true;
    },
    saToLogin(data) {
      return dsf.http
        .get("/survey/assistant/getSurveyAssistantSsoUrl")
        .then((res) => {
          let { success, message, data } = res.data;
          if (success) {
            if (data) {
              location.replace(data);
            } else {
              dsf.layer.message("跳转路径不存在", false);
            }
          } else {
            dsf.layer.message(message, false);
          }
        });
    },
  },
  created() {
    this.getQrCode();
  },
};
</script>
